import { LoaderRing } from "./Loaders";

export const TemplateForm = ({
  children,
  onSubmit,
  textButton,
  colorLoader,
  classButton,
  containerButton,
  isValid,
  styleIsValid,
  loading,
}) => {

  return (
    <form className="space-y-14" onSubmit={onSubmit}>
      {children}
      <div className={`${containerButton}`}>
        <button
          type="submit"
          className={`rounded-lg h-11 sm:text-sm text-sm transition-colors duration-300 ease-in-out px-5 relative ${classButton} ${
            isValid ? ` ${styleIsValid}` : "cursor-not-allowed opacity-60 "
          }`}
          disabled={!isValid || loading}
        >
          {loading ? "Enviando" : `${textButton}`}{" "}
          <span className="absolute top-1/2 right-4 transform -translate-y-1/2">
            {loading ? <LoaderRing colorLoader={colorLoader} /> : <i className="fas fa-lock text-sm" />}
          </span>
        </button>
      </div>
    </form>
  );
};